import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BpApi extends ApiCommon {

  getBp(search?: any): Observable<any> {
    return this.apiServer.bp.getBp(search);
  }

  getBpDetail(bpNo: any): Observable<any> {
    return this.apiServer.bp.getBpDetail(bpNo);
  }

  saveCustomer(customer): Observable<any> {
    return this.apiServer.bp.saveCustomer(customer);
  }
}
